import { styled } from 'styled-components';
import { FloatMenuProps } from './float-menu-types';

export const SiderStyled = styled.div<FloatMenuProps>`
  color: ${({ theme }) => theme.colors.text.headings};
  position: fixed;
  right: 16px;
  top: 16px;
  width: 56px;
  height: auto;
  overflow: visible;
  z-index: 10;
  box-sizing: border-box;
  @media (max-width: 1080px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    width: 130px;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  }
`;

export const MenuStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.theme.contentBg};
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
  backdrop-filter: blur(8px);
  box-sizing: border-box;
  padding: 8px;
  gap: 24px;

  
  @media (max-width: 1080px) {
    flex-direction: row;
    width: fit-content;
    margin: 0 auto;
  }
`;

export const MenuItemStyled = styled.div<{ $selected: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $selected, theme }) => $selected ? theme.colors.theme.brandColor3 : 'transparent'};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  color: ${({ theme }) =>  theme.colors.common.white};
  
  &:hover {
    background-color: ${({ theme, $selected }) =>  $selected  ? 'brightness(0) invert(1)' : theme.colors.theme.brandColor3};
  }

  img {
    filter: ${({ theme, $selected }) => 
      theme.mode === "dark" || $selected? 'brightness(0) invert(1)' : 'none'
    };
  }
`;

export const IconWrapperStyled = styled.div`
  font-size: 24px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconStyled = styled.img`
  width: 24px;
  height: 24px;
`;


export const MenuTextStyled = styled.p`
  position: absolute;
  top: 50%;
  right: 100%; 
  transform: translateX(45%) translateY(-50%);
  background-color: ${({ theme }) => theme.colors.theme.brandColor3};
  color: inherit;
  padding: 11px;
  padding-right: 40px;
  border-radius: 32px;
  opacity: 0;
  white-space: nowrap;
  transition: opacity 0.3s ease, transform 0.3s ease;

  z-index: 4;
  ${MenuItemStyled}:hover & {
    opacity: 1;
    transform: translateX(37%) translateY(-50%);
  }

  @media (max-width: 1080px) {
    display: none;
  }
`;
